<main class="mobile_ordered" v-if="app.cart">
    <div id="background"></div>
    <header>
        <header-component></header-component>
        <div class="nav">
            <h1>{{_('cart')}}</h1>
            <span class="icon back" @click="back()"> chevron_left </span>
        </div>
    </header>

    <table class="c-table">
        <thead>
            <th class="first_cell">{{ _('building_name') }}</th>
            <th class="pull_down">{{ _('quantity') }}</th>
            <th class="merchandise_price"></th>
            <th class="delete_button"></th>
        </thead>
        <tbody>
            <tr v-for="(order, index) in app.cart.orders">
                <td class="merchandise_name">
                    {{ _(order.item.texts.title) }}
                    <p v-if="order.schedule_id">{{ order.use_date }}</p>
                    <p v-if="order.schedule_id">
                        {{ order.start_time }} ～ {{ order.end_time }}
                    </p>
                </td>
                <td>
                    <label class="wrap-input select pull_down">
                        <select
                            :value="order.quantity"
                            @change.number="changeQuantity(order, $event.target.value)"
                        >
                            <option v-for="n in order.stock" :value="n">
                                {{ n }}{{ _(order.item.texts.unit) }}
                            </option>
                        </select>
                    </label>
                </td>
                <td class="merchandise_price">
                    {{ order.amount_including_tax | price }}
                </td>
                <td class="delete_button" @click="remove(order)">
                    {{ _('remove') }}
                </td>
            </tr>
        </tbody>
        <tfoot>
            <td class="first_cell">{{ _('total') }}（{{ _('include_tax') }}</td>
            <td></td>
            <td class="merchandise_price">
                {{ app.cart.totalAmountIncludingTax | price}}
            </td>
            <td></td>
        </tfoot>
    </table>
    <template v-if="_(app.house.mobile_order_caution)">
        <hr />
        <section class="remarks">
            <pre>{{ _(app.house.mobile_order_caution) }}</pre>
        </section>
        <hr />
    </template>

    <div class="shadow flex" v-if="showModal">
        <div class="modal">
            <div class="modal-header">
                <h1>{{_('input_seat_title')}}</h1>
                <span class="control" @click="showModal = false">close</span>
                <hr />
            </div>
            <div class="modal-body">
                <div class="seat_input_message">
                    {{ _('include_item_need_to_input_seat') }}
                </div>
                <h2>{{ _('need_seat_input') }}</h2>
                <hr />
                <label class="wrap-input">
                    <input type="text" v-model="seat_name" />
                </label>
            </div>

            <div class="buttons">
                <button
                    @click.once="completeMobileOrder()"
                    :disabled="!seat_name"
                >
                    {{_('specify_a_seat')}}
                </button>
            </div>
        </div>
    </div>

    <footer>
        <button class="white" @click="app.setPage('MerchandiseCategories')">
            {{_('continue_shopping')}}
        </button>
        <button
            v-if="app.cart.orders.length"
            @click.once="confirmPurchase()"
            style="margin: 0"
        >
            {{_('confirm_order')}}
        </button>
    </footer>
</main>
